import ShowCard from "../ShowCard/ShowCard"
import {
  type ScheduledShowCardProps,
  ShowCardType,
} from "../ShowCard/types"

type Props = Omit<ScheduledShowCardProps, "type">

export default function ScheduledShowCard(props: Props) {
  return <ShowCard type={ShowCardType.Scheduled} {...props} />
}
